// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"7778c8e9","99":"cc0bc26c","146":"4b6e1333","175":"590dae38","204":"1b21d2a7","349":"efcabfe8","453":"064bf14a","479":"54e6fe0a","655":"18baccae","674":"3c9cfb4d","768":"7122e029","813":"bfcb9a1f","963":"3d4f4e4d"}[chunkId] + ".chunk.js";
};